import React, { memo, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getOperatorMissionStatus,
  getMissionOperatorFleetIdForSubscribe,
  setMissionOperatorFleetId,
} from "Slices/operatorData";
import { getIsStationEmpty } from "Slices/operatorStation";
import { StationPicker } from "./components/StationPicker/StationPicker";
import { VehicleWayStatus } from "./components/VehicleWayStatus";
import { VehicleStatuses } from "./components/VehicleStatuses";
import { SelectStation } from "./components/SelectStation";
import { FleetPicker } from "../common/FleetPicker";
import { SemanticMapPicker } from "Components/common/SemanticMapPicker";

import {
  OperatorSidePanelWrapperStyled,
  MissionOperatorBoardStyled,
  PickerPaddingStyled,
  LoadingStyled,
} from "./styles";

export const OperatorSidePanel = memo(() => {
  const dispatch = useDispatch();
  const [isSelectStationModalOpen, setSelectStationModalVisible] =
    useState<boolean>(false);

  const operatorMissionStatus = useSelector(getOperatorMissionStatus);
  const isStationEmpty = useSelector(getIsStationEmpty);
  const operatorFleetIdForSubscribe = useSelector(
    getMissionOperatorFleetIdForSubscribe
  );

  const handleSelectedFleet = useCallback((fleetId: string | null) => {
    dispatch(setMissionOperatorFleetId(fleetId));
  }, []);

  const initFleetId =
    operatorMissionStatus &&
    operatorMissionStatus !== "NO_MISSION" &&
    operatorFleetIdForSubscribe
      ? operatorFleetIdForSubscribe
      : "";

  return (
    <OperatorSidePanelWrapperStyled>
      <MissionOperatorBoardStyled>
        <PickerPaddingStyled>
          <SemanticMapPicker />
        </PickerPaddingStyled>
        <PickerPaddingStyled>
          {operatorMissionStatus || isStationEmpty ? (
            <FleetPicker
              shouldUseSavedFleet
              initFleetId={initFleetId}
              handleSelectedFleet={handleSelectedFleet}
              isPickerDisabled={
                operatorMissionStatus && operatorMissionStatus !== "NO_MISSION"
              }
            />
          ) : (
            <LoadingStyled>Loading...</LoadingStyled>
          )}
        </PickerPaddingStyled>
        <StationPicker
          isSelectStationModalOpen={isSelectStationModalOpen}
          setSelectStationModalVisible={setSelectStationModalVisible}
        />
        {operatorMissionStatus && <VehicleWayStatus />}
      </MissionOperatorBoardStyled>
      <VehicleStatuses />
      {isSelectStationModalOpen && (
        <SelectStation
          setSelectStationModalVisible={setSelectStationModalVisible}
        />
      )}
    </OperatorSidePanelWrapperStyled>
  );
});
